import * as actions from '../actions/index' 

let docBarData = {
    popupType: "OBSO",
    popupOpen: false,
    selectedDocs: []
}

const docBarReducer = (state = docBarData, action) => {
    switch(action.type){
        case actions.RESET_OBSO_STATE:{
            return Object.assign({}, state, {selectedDocs: [], popupOpen:false, popupType: "OBSO"})
        }
        case actions.MARK_OSOLETE_ICON:{
            return Object.assign({}, state, {openAllFolders: !state.openAllFolders});
        }
        case actions.UPDATE_DOC_ARR:{
            const newSelectedDocs = [...state.selectedDocs]
            const elementInd = newSelectedDocs.indexOf(action.docid)
            if(elementInd === -1){
                newSelectedDocs.push(action.docid);
            }
            else{
                newSelectedDocs.splice(elementInd, 1)
            }
            return Object.assign({}, state, {selectedDocs: newSelectedDocs});
        }
        case actions.UPDATE_POPUP_TYPE:{
            return Object.assign({}, state, {popupType: action.popupType, selectedDocs: []})
        }
        case actions.UPDATE_POPUP_OPEN:{
            return Object.assign({}, state, {popupOpen: !state.popupOpen, selectedDocs:[]})
        }
        default:
            return state;
    }
}

export default docBarReducer;